import { CoreModule } from "dynamsoft-core";
import { LicenseManager } from "dynamsoft-license";
import "dynamsoft-barcode-reader";

CoreModule.engineResourcePaths.rootDirectory = "https://cdn.jsdelivr.net/npm/";
LicenseManager.initLicense(process.env.REACT_APP_DYNAMSOFT_LICENCE);
CoreModule.loadWasm(["DBR"]);